import React, { useEffect } from "react";

import { useGetCartQuery } from "../../api/wordpress.ts";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import { DevTools } from "../dev/DevTools.tsx";
import Header from "../elements/Header.tsx";
import { Image } from "../elements/Image.tsx";
import CartWarningModal from "../modals/CartWarningModal.tsx";
import OrderBreakdown from "./OrderBreakdown.tsx";
import { Sidebar } from "./Sidebar.tsx";
import SpecsTable from "./SpecsTable.tsx";
import TopBar from "./TopBar.tsx";

export const NewOrderScreen = () => {
  const {
    selectedVehiclePrettyName,
    selectedVariants,
    orderMode,
    selectedGvmUpgrade,
  } = useVehicleSelection();

  const { data: cart } = useGetCartQuery();
  const [showModal, setShowModal] = React.useState(false);

  useEffect(() => {
    if (cart && cart.items_count > 0) {
      setShowModal(true);
    }
  }, [cart]);

  const showDisclaimer = selectedVehiclePrettyName.includes("Toyota");

  const vehicleImage = selectedVariants
    .map((variant) => {
      return variant.acf.gvm_builder_image?.url;
    })
    .filter((url) => url)
    .reverse()[0];

  return (
    <>
      <TopBar />
      <DevTools />
      <div className="mb-[24px] mt-[16px] hidden lg:block xl:hidden">
        <Header size="3xl" hideUnderline>
          {selectedVehiclePrettyName}
        </Header>
      </div>
      {showModal && orderMode === "new" && (
        <CartWarningModal onClose={() => setShowModal(false)} />
      )}
      <div className="mx-auto">
        <div className="flex flex-col lg:flex-row gap-4 mb-6">
          <div className="flex-grow">
            <div className="relative overflow-hidden lg:rounded-lg">
              {vehicleImage ? (
                <>
                  <div className="absolute inset-0 bg-gradient-to-b from-[#ccc] via-[#ccc] to-white xl:from-white xl:via-[#ccc] xl:to-white z-10"></div>
                  <Image
                    src={vehicleImage}
                    alt={selectedVehiclePrettyName}
                    className="w-full h-full object-cover z-20"
                  />
                  <div className="absolute bottom-[23%] md:bottom-[25%] left-1/2 -translate-x-1/2 w-[80%] h-[20px] bg-black/60 rounded-full blur-sm z-30"></div>
                </>
              ) : (
                <>
                  <div className="absolute inset-0 bg-gradient-to-b from-[#eee] via-[#eee] to-white xl:from-white xl:via-[#eee] xl:to-white z-10"></div>
                  <div className="relative w-full flex justify-center text-center items-center text-2xl xl:text-4xl aspect-[2560/1843] z-20 opacity-40">
                    {selectedVariants[0]
                      ? "No image available for this vehicle"
                      : "Select your vehicle using the options above"}
                  </div>
                </>
              )}
              {showDisclaimer && (
                <div className="absolute bottom-4 lg:bottom-12 z-50 w-full text-center px-4">
                  *All parts listed are to suit this vehicle and are not Toyota
                  Genuine Accessories.
                </div>
              )}
            </div>

            {/* Render the specs table directly under the vehicle image so the GVM
                specifications are prominent as soon as a kit is selected — this is the
                info customers and facilities previously relied on from the product page,
                rather than buried at the bottom of the configuration flow. */}
            {selectedGvmUpgrade?.id != null && (
              <SpecsTable postId={Number(selectedGvmUpgrade.id)} />
            )}

            <div className="hidden lg:block">
              {/*<Summary />*/}
              <OrderBreakdown />
            </div>
          </div>
          <div className="md:min-w-[400px] md:max-w-[400px] flex flex-col gap-4 px-4 lg:px-0">
            <Sidebar />
          </div>
        </div>
      </div>

      <div className="lg:hidden">
        <OrderBreakdown />
      </div>
    </>
  );
};
